"use client"

import { useState } from "react"
import { Link } from 'react-router-dom';
import "./IYQ2025Page.css"
import IYQ1 from '../../assets/IYQ1.png';
import IYQ2 from '../../assets/IYQ2.png';
import videoThumbnail from '../../assets/iyq-thumbnail.jpg'; 

// Dialog Component
const Dialog = ({ children, open, onOpenChange }) => {
  if (!open) return null

  return (
    <div className="iyq2025-dialog-overlay" onClick={() => onOpenChange(false)}>
      <div className="iyq2025-dialog-content" onClick={(e) => e.stopPropagation()}>
        <button className="iyq2025-dialog-close" onClick={() => onOpenChange(false)}>
          ×
        </button>
        {children}
      </div>
    </div>
  )
}
  

// Icon Components 
const PlayIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
  </svg>
)

const AtomIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="1" fill="currentColor" />
    <path
      d="M20.2 20.2C21.4 18.9 22 17.5 22 16C22 14.5 21.4 13.1 20.2 11.8"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path d="M3.8 3.8C2.6 5.1 2 6.5 2 8C2 9.5 2.6 10.9 3.8 12.2" stroke="currentColor" strokeWidth="2" fill="none" />
    <path
      d="M20.2 3.8C21.4 5.1 22 6.5 22 8C22 9.5 21.4 10.9 20.2 12.2"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M3.8 20.2C2.6 18.9 2 17.5 2 16C2 14.5 2.6 13.1 3.8 11.8"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
  </svg>
)

const UsersIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" fill="none" />
    <path
      d="M22 21V19C22 18.1332 21.7275 17.3332 21.2426 16.6665C20.7578 15.9999 20.0813 15.5014 19.2991 15.2426"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
  </svg>
)

const AwardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="8" r="6" stroke="currentColor" strokeWidth="2" fill="none" />
    <path d="M15.477 12.89L17 22L12 19L7 22L8.523 12.89" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
)

const CalendarIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2" fill="none" />
    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" />
    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" />
    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2" />
  </svg>
)

const GraduationCapIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 10V16C22 17 21 18 20 18C19 18 18 17 18 16V10" stroke="currentColor" strokeWidth="2" fill="none" />
    <path d="M2 10L12 5L22 10L12 15L2 10Z" stroke="currentColor" strokeWidth="2" fill="none" />
    <path d="M6 12V17C6 18.5 8.5 20 12 20C15.5 20 18 18.5 18 17V12" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
)

const CodeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="16,18 22,12 16,6" stroke="currentColor" strokeWidth="2" fill="none" />
    <polyline points="8,6 2,12 8,18" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
)

const MegaphoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 11L18 5V19L3 13V11Z" stroke="currentColor" strokeWidth="2" fill="none" />
    <path
      d="M11.6 16.8C12.1 17.4 12.9 18 14 18C15.7 18 17 16.7 17 15V13"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
  </svg>
)

const CoffeeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8H19C20.5 8 22 9.5 22 11S20.5 14 19 14H18V8Z" stroke="currentColor" strokeWidth="2" fill="none" />
    <path
      d="M2 8H18V15C18 16.5 16.5 18 15 18H5C3.5 18 2 16.5 2 15V8Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <line x1="6" y1="1" x2="6" y2="4" stroke="currentColor" strokeWidth="2" />
    <line x1="10" y1="1" x2="10" y2="4" stroke="currentColor" strokeWidth="2" />
    <line x1="14" y1="1" x2="14" y2="4" stroke="currentColor" strokeWidth="2" />
  </svg>
)

const BookOpenIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 3H8C9.5 3 11 4 12 5C13 4 14.5 3 16 3H22V18H16C14.5 18 13 19 12 20C11 19 9.5 18 8 18H2V3Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <polyline points="12,5 12,20" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
)

const SparklesIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.937 15.5A2 2 0 0 0 8.5 14.063L7.5 12L8.5 9.937A2 2 0 0 0 9.937 8.5L12 7.5L14.063 8.5A2 2 0 0 0 15.5 9.937L16.5 12L15.5 14.063A2 2 0 0 0 14.063 15.5L12 16.5L9.937 15.5Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path d="M20 3V7" stroke="currentColor" strokeWidth="2" />
    <path d="M22 5H18" stroke="currentColor" strokeWidth="2" />
    <path d="M4 17V21" stroke="currentColor" strokeWidth="2" />
    <path d="M6 19H2" stroke="currentColor" strokeWidth="2" />
  </svg>
)

const ArrowRightIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2" />
    <polyline points="12,5 19,12 12,19" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
)

const IYQ2025Page = () => {
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const videoId = "HOSOuxIYrNY";


  const events = [
    {
      date: "April 2025",
      title: "Quantum Day Meetup",
      description: "A special day dedicated to quantum science with talks, demonstrations, and community networking",
      icon: UsersIcon,
      color: "blue-cyan",
    },
    {
      date: "May 2025",
      title: "Quantum 101: In Collaboration with ALX Learners",
      description: "Foundational quantum computing program designed for beginners in partnership with ALX",
      icon: GraduationCapIcon,
      color: "green-teal",
    },
    {
      date: "June 2025",
      title: "The Quantum Code: Algorithms",
      description: "Deep dive into quantum algorithms with hands-on coding sessions and practical implementations",
      icon: CodeIcon,
      color: "purple-pink",
    },
    {
      date: "August 2025",
      title: "Quantum City Campaign",
      description: "City-wide quantum awareness campaign bringing quantum science to the public",
      icon: MegaphoneIcon,
      color: "orange-red",
    },
    {
      date: "September 2025",
      title: "Quantum Bootcamp: In Collaboration with Strathmore University",
      description: "Intensive quantum computing bootcamp in partnership with Strathmore University",
      icon: BookOpenIcon,
      color: "indigo-purple",
    },
    {
      date: "October 2025",
      title: "Quantum Mixer: A Global Exchange of Ideas",
      description: "International networking event connecting quantum minds from around the world",
      icon: CoffeeIcon,
      color: "cyan-blue",
    },
    {
      date: "October 2025",
      title: "Inaugural Africa Quantum Summit: Kenya Edition",
      description:
        "Historic first Africa Quantum Summit hosted in Kenya, marking a milestone for quantum science in Africa",
      icon: AwardIcon,
      color: "yellow-orange",
    },
  ]

  return (
    <div className="iyq2025-page">
      {/* Hero Section */}
      <section className="iyq2025-hero-section">
        <div className="iyq2025-hero-background"></div>
        <div className="iyq2025-hero-content">
          <div className="iyq2025-hero-badges">
            <span className="iyq2025-badge iyq2025-badge-unesco">UNESCO Initiative</span>
            <span className="iyq2025-badge iyq2025-badge-year">2025</span>
          </div>

          <h1 className="iyq2025-hero-title">
            International Year of
            <span className="iyq2025-hero-title-gradient">Quantum 2025</span>
          </h1>

          <p className="iyq2025-hero-description">
            Join our quantum community in celebrating UNESCO's International Year of Quantum. Together, we're advancing
            quantum awareness, education, and innovation for a quantum future.
          </p>

          <div className="iyq2025-hero-buttons">
            <Link to="/contact-us">
            <button className="iyq2025-btn iyq2025-btn-primary">
              <SparklesIcon />
              Partner with Us
            </button>
            </Link>

            <a 
              href="https://quantum2025.org/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
            <button className="iyq2025-btn iyq2025-btn-secondary">
              Learn About IYQ 2025
              <ArrowRightIcon />
            </button>
            </a>
          </div>
        </div>
      </section>

      {/* About IYQ 2025 */}
      <section className="iyq2025-about-section">
        <div className="iyq2025-container">
          <div className="iyq2025-about-grid">
            {/* Video Dialog */}
           <div className="iyq2025-video-container">
  <div className="iyq2025-video-wrapper">
    <div 
      className="iyq2025-video-placeholder"
      style={{
        backgroundImage: `url(${videoThumbnail})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="iyq2025-video-overlay"></div>
      <button className="iyq2025-video-play-button" onClick={() => setVideoDialogOpen(true)}>
        <PlayIcon />
      </button>
      <div className="iyq2025-video-info">
        <h3 className="iyq2025-video-title">IYQ 2025</h3>
        <p className="iyq2025-video-description">
          "What is Quantum?" 2025 International Year of Quantum Science and Technology
        </p>
      </div>
    </div>
  </div>
</div>

            {/* About Content */}
            <div className="iyq2025-about-content">
              <h2 className="iyq2025-about-title">
                About the International Year of &nbsp;
                <span className="iyq2025-about-title-gradient">Quantum</span>
              </h2>
              <div className="iyq2025-about-text">
                <p>
                  UNESCO has declared 2025 as the International Year of Quantum Science and Technology, marking 100
                  years since the development of quantum mechanics. This global initiative aims to increase public
                  awareness of quantum science and its applications.
                </p>
                <p>
                  The year-long celebration promotes quantum literacy, inspires the next generation of quantum
                  scientists, and highlights the transformative potential of quantum technologies across industries.
                </p>
              </div>

              <div className="iyq2025-about-features">
                <div className="iyq2025-feature-item iyq2025-feature-awareness">
                  <AtomIcon />
                  <h4>Quantum Awareness</h4>
                </div>
                <div className="iyq2025-feature-item iyq2025-feature-collaboration">
                  <UsersIcon />
                  <h4>Global Collaboration</h4>
                </div>
                <div className="iyq2025-feature-item iyq2025-feature-innovation">
                  <CodeIcon />
                  <h4>Future Innovation</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Events Timeline */}
      <section className="iyq2025-timeline-section">
        <div className="iyq2025-container">
          <div className="iyq2025-section-header">
            <h2 className="iyq2025-section-title">Our 2025 Quantum Journey</h2>
            <p className="iyq2025-section-description">
              Follow our year-long celebration of quantum science with key events and milestones throughout the
              International Year of Quantum.
            </p>
          </div>

          <div className="iyq2025-timeline-container">
            <div className="iyq2025-timeline-line"></div>

            {events.map((event, index) => (
              <div
                key={index}
                className={`iyq2025-timeline-item ${index % 2 === 0 ? "iyq2025-timeline-left" : "iyq2025-timeline-right"}`}
              >
                <div className="iyq2025-timeline-content">
                  <div className="iyq2025-event-card">
                    <div className="iyq2025-event-header">
                      <div className={`iyq2025-event-icon iyq2025-gradient-${event.color}`}>
                        <event.icon />
                      </div>
                      <div className="iyq2025-event-date">
                        <CalendarIcon />
                        <span>{event.date}</span>
                      </div>
                    </div>
                    <h3 className="iyq2025-event-title">{event.title}</h3>
                    <p className="iyq2025-event-description">{event.description}</p>
                  </div>
                </div>
                <div className={`iyq2025-timeline-dot iyq2025-gradient-${event.color}`}></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Logos Section */}
      <section className="iyq2025-logos-section">
        <div className="iyq2025-container">
          <div className="iyq2025-logos-header">
            <p className="iyq2025-logos-description">
              Proudly supporting UNESCO's International Year of Quantum initiative alongside global quantum
              communities
            </p>
          </div>

          <div className="iyq2025-logos-container">
            <div className="iyq2025-logo-item">
                <img
                  src={IYQ1}
                  alt="World Quantum Day"
                  className="iyq2025-logo-image"
                />
            </div>

            <div className="iyq2025-logos-divider"></div>

            <div className="iyq2025-logo-item">
                <img
                  src={IYQ2}
                  alt="Quantum City"
                  className="iyq2025-logo-image"
                />
            </div>
          </div>
        </div>
      </section>

      {/* Video Dialog */}
      <Dialog open={videoDialogOpen} onOpenChange={setVideoDialogOpen}>
        <div className="iyq2025-video-dialog">
          <div className="iyq2025-video-player">
            <iframe
              width="100%"
              height="400"
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
              title="UNESCO IYQ 2025 Official Announcement"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default IYQ2025Page
